<template>
    <NuxtLayout>
        <UiSkipToContent main-content-id="quoteForm" />
        <div id="topBanner"></div>
        <NuxtPage />
    </NuxtLayout>
</template>

<script setup>
import { useLDClient } from 'launchdarkly-vue-client-sdk';

const ldClient = ref(null);
const config = useRuntimeConfig();
const beforeunload = async (event) => {
    await ldClient.value
        .flush()
        .then(() => {})
        .catch((err) => {
            console.error('Error', err);
        });
};

onMounted(() => {
    if (config.public.LAUNCH_DARKLY_CLIENT_KEY) {
        ldClient.value = useLDClient();
        window.addEventListener('beforeunload', beforeunload);
    }
});
onUnmounted(() => {
    if (config.public.LAUNCH_DARKLY_CLIENT_KEY) {
        ldClient.value = useLDClient();
        window.removeEventListener('beforeunload', beforeunload);
    }
});
</script>

<style lang="postcss">
@import '~/assets/css/tailwind.css';
@import '~/assets/css/airport-landing.css';
@import '@nuxt-monorepo/base/app/assets/css/animations.css';
@import '@nuxt-monorepo/base/app/assets/css/richtext.css';
@import '~/assets/css/inputs.css';

body:has(dialog[open]) {
    overflow: hidden;
}

@media (max-width: 640px) {
    html {
        font-family: Arial, Helvetica, sans-serif;
        @media (hover: none) and (pointer: coarse) {
            input,
            textarea,
            select {
                font-size: 1rem !important; /* to prevent zoom on input focus on mobile Safari */
            }
        }
    }
}
</style>
